import FoodBenefitDelegations from 'food-benefit.module/common/models/delegations';

class delegationDataAssembler {
  static assemble(dataArray) {
    let delegations = [];
    dataArray.delegations.forEach((data) => {
      let delegation = new FoodBenefitDelegations();
      delegation.startDate = data.startDate || '';
      delegation.endDate = data.endDate || '';
      delegation.employeeId = data.employeeId || '';
      delegation.name = data.name || '';
      delegation.email = data.email || '';
      delegation.isNotified = data.isNotified || false;
      delegation.type = data.type || '';
      delegation.id = data.id || '';
      delegations.push(delegation);
    });
    return delegations;
  }
}

export default delegationDataAssembler;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/delegationRepository/foodDelegation.assemblers.js